import { useState } from "react";
import { toast } from "sonner";
import { http, formatApiError } from "../../lib/api";
import { Modal, F, inp, btnPrimary, btnGhost, today } from "./common";

export const ReturnDialog = ({ url, label, onClose, onDone }) => {
  const now = new Date();
  const [v, setV] = useState({ date: today(), time: now.toTimeString().slice(0, 5), returned_by: "", reason: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await http.post(url, v); toast.success("Restitution enregistrée"); onDone(); onClose(); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Modal title={`Restitution — ${label}`} onClose={onClose} testid="return-dialog">
      <div className="grid grid-cols-2 gap-3">
        <F label="Date"><input type="date" className={inp} value={v.date} onChange={(e) => setV({ ...v, date: e.target.value })} data-testid="return-date" /></F>
        <F label="Heure"><input type="time" className={inp} value={v.time} onChange={(e) => setV({ ...v, time: e.target.value })} data-testid="return-time" /></F>
        <F label="Responsable qui a restitué" className="col-span-2"><input className={inp} value={v.returned_by} onChange={(e) => setV({ ...v, returned_by: e.target.value })} placeholder="Nom et prénom" data-testid="return-by" /></F>
        <F label="Motif" className="col-span-2"><textarea rows={2} className={inp} value={v.reason} onChange={(e) => setV({ ...v, reason: e.target.value })} placeholder="Fin de contrat, panne, usure, remplacement…" data-testid="return-reason" /></F>
      </div>
      {(!v.date || !v.time || v.returned_by.trim().length < 2 || v.reason.trim().length < 2) && <p className="text-xs text-amber-700 mt-2" data-testid="return-missing">Renseignez la date, l'heure, le responsable et le motif.</p>}
      <div className="flex justify-end gap-2 mt-3">
        <button className={btnGhost} onClick={onClose}>Annuler</button>
        <button className={btnPrimary} disabled={busy || !v.date || !v.time || v.returned_by.trim().length < 2 || v.reason.trim().length < 2} onClick={save} data-testid="return-save">Enregistrer la restitution</button>
      </div>
    </Modal>
  );
};

export const ReturnInfo = ({ r }) => r ? (
  <div className="text-[11px] text-slate-500 mt-0.5" data-testid="return-info">Restitué le {r.date.split("-").reverse().join("/")} à {r.time} par {r.returned_by} — {r.reason}</div>
) : null;
